// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-remark.badge-light-info[data-v-20852588]{color:#166987!important;background-color:rgba(22,105,135,.137254902)}.badge-remark.badge-light-warning[data-v-20852588]{color:#ff9f00!important;background-color:rgba(255,159,0,.137254902)}", ""]);
// Exports
module.exports = exports;
